import { IIndexable } from '../Utils';

const GR_BUCKET_BASE_URL = new RegExp(/\$\{bucketBaseURL\}/g);
export interface ILocalizedString {
	[languageCode: string]: string;
}

export function isILocalizedString(a_what: any): a_what is ILocalizedString
{
	if (typeof a_what !== "object") {
		return false;
	}
	const keys = Object.keys(a_what);
	for (let k of keys) {
		if (k.length !== 2 || typeof a_what[k] !== "string") {
			return false;
		}
	}
	return true;
}

export interface IGame
{
	title: ILocalizedString;
	symbolicId: string;
	iconURL: string;
	frameURL: string;
	tags?: string[];
	description_short?: ILocalizedString;
	description_long?: ILocalizedString;
	instructions_short?: ILocalizedString;
	instructions_long?: ILocalizedString;
}

export function isIGame(a_what: any): a_what is IGame
{
	const rv = typeof a_what === "object"
		&& "title" in a_what
		&& isILocalizedString(a_what.title)
		&& "symbolicId" in a_what
		&& typeof a_what.symbolicId === "string"
		&& "iconURL" in a_what
		&& typeof a_what.iconURL === "string"
		&& "frameURL" in a_what
		&& typeof a_what.frameURL === "string"
		&& (!("tags" in a_what) || (Array.isArray(a_what.tags) && a_what.tags.every((a_it: any) => typeof a_it === "string")))
		&& (!("description_short" in a_what) || (isILocalizedString(a_what.description_short)))
		&& (!("description_long" in a_what) || (isILocalizedString(a_what.description_long)))
		&& (!("instructions_short" in a_what) || (isILocalizedString(a_what.instructions_short)))
		&& (!("instructions_long" in a_what) || (isILocalizedString(a_what.instructions_long)));
	return rv;
}

export interface IGameCategory
{
	categoryName: ILocalizedString;
	iconURL: string;
	games: IGame[];
}

export function isIGameCategory(a_what: any): a_what is IGameCategory
{
	const rv = typeof a_what === "object"
		&& "categoryName" in a_what
		&& isILocalizedString(a_what.categoryName)
		&& "iconURL" in a_what
		&& typeof a_what.iconURL === "string"
		&& "games" in a_what
		&& Array.isArray(a_what.games)
		&& a_what.games.every((a_g: any) => isIGame(a_g));
		return rv;
}

export interface IGames
{
	[section: string]: IGameCategory;
}

export function isIGames(a_what: any): a_what is IGames
{
	if (typeof a_what !== "object") {
		return false;
	}
	for (let p in a_what) {
		if (!isIGameCategory(a_what[p])) {
			return false;
		}
	}
	return true;
}

export class MGame
{
	title: ILocalizedString;
	symbolicId: string;
	iconURL: string;
	frameURL: string;
	category: string;
	tags: string[];
	description_short: ILocalizedString;
	description_long: ILocalizedString;
	instructions_short: ILocalizedString;
	instructions_long: ILocalizedString;

	constructor(a_obj: any, a_category: string, a_bucketBaseURL?: string)
	{
		this.title = {};
		this.symbolicId = "";
		this.iconURL = "";
		this.frameURL = "";
		this.category = "";
		this.tags = [];
		this.description_short = {};
		this.description_long = {};
		this.instructions_short = {};
		this.instructions_long = {};
		if (isIGame(a_obj)) {
			this.title = a_obj.title;
			this.symbolicId = a_obj.symbolicId;
			this.iconURL = a_obj.iconURL;
			this.frameURL = a_obj.frameURL;
			if (a_bucketBaseURL !== undefined) {
				this.iconURL = this.iconURL.replace(GR_BUCKET_BASE_URL, a_bucketBaseURL);
				this.frameURL = this.frameURL.replace(GR_BUCKET_BASE_URL, a_bucketBaseURL);
			}
			if (a_obj.tags !== undefined) {
				this.tags = a_obj.tags;
			}
			if (a_obj.description_short !== undefined) {
				this.description_short = a_obj.description_short;
			}
			if (a_obj.description_long !== undefined) {
				this.description_long = a_obj.description_long;
			}
			if (a_obj.instructions_short !== undefined) {
				this.instructions_short = a_obj.instructions_short;
			}
			if (a_obj.instructions_long !== undefined) {
				this.instructions_long = a_obj.instructions_long;
			}
		}
		if (a_category !== undefined) {
			this.category = a_category;
		}
	}
}

export class MGameCategory {
	categoryName: ILocalizedString;
	iconURL: string;
	games: MGame[];
	category: string;

	constructor(a_obj: any, a_category: string, a_bucketBaseURL?: string)
	{
		this.categoryName = {};
		this.iconURL = "";
		this.games = [];
		this.category = "";
		if (isIGameCategory(a_obj)) {
			this.category = a_category;
			this.categoryName = a_obj.categoryName;
			this.iconURL = a_obj.iconURL;
			if (a_bucketBaseURL !== undefined) {
				this.iconURL = this.iconURL.replace(GR_BUCKET_BASE_URL, a_bucketBaseURL);
			}
			for (let g of a_obj.games) {
				this.games.push(new MGame(g, this.category, a_bucketBaseURL))
			}
		}
	}
}

export class MGames
{
	categories: IIndexable<MGameCategory>;
	protected mBySymbolicId: IIndexable<MGame>

	bySymbolicId(a_symbolicId: string): MGame | undefined
	{
		return this.mBySymbolicId[a_symbolicId];
	}

	constructor(a_obj: any, a_bucketBaseURL?: string)
	{
		this.categories = {};
		this.mBySymbolicId = {};
		if (isIGames(a_obj)) {
			for (let c in a_obj) {
				this.categories[c] = new MGameCategory(a_obj[c], c, a_bucketBaseURL);
				for (let g of this.categories[c].games) {
					this.mBySymbolicId[g.symbolicId] = g;
				}
			}
		}
	}
}
